import React from 'react';
import { Reveal } from './Reveal';
import { frustrations } from '../data/homepage';
export function Frustrations() {
  return <section aria-labelledby="frustrations-heading" className="on-light bg-paper py-24 md:py-32" data-id="element-34" data-mp="2hckknb1nivhu">
      <div className="mx-auto max-w-7xl px-6 md:px-10" data-id="element-35" data-mp="2dck6lrigsmbb">
        <Reveal className="max-w-3xl" data-id="element-36" data-mp="28cxtdi2mz62i">
          <h2 id="frustrations-heading" className="font-serif text-4xl font-semibold leading-tight text-navy md:text-5xl" data-id="element-37" data-mp="28dz1pes9pegj">
            If the system has worn you down, that's not on you.
          </h2>
          <div aria-hidden="true" className="mt-8 h-px w-16 bg-gold" data-id="element-38" data-mp="312o55kgspvvg" />
        </Reveal>

        <ul className="mt-14 grid gap-6 md:grid-cols-3 md:gap-8" data-id="element-39" data-mp="2w175ttdymhgz">
          {frustrations.map((item, i) => <li key={item.quote} data-id="element-40" data-mp="2r2nltyixffr9" data-mpi={i}>
              <Reveal delay={i * 0.05} className="flex h-full flex-col rounded-sm border border-navy/10 bg-white p-8 md:p-10" data-id="element-41" data-mp="2r5jh1f3e3qc0">
                <h3 className="font-serif text-2xl font-semibold italic leading-snug text-navy md:text-[1.7rem]" data-id="element-42" data-mp="1fnh2iounzx8e">
                  “{item.quote}”
                </h3>
                <p className="mt-5 text-lg leading-relaxed text-charcoal" data-id="element-43" data-mp="1s3chxyvftqxg">{item.answer}</p>
              </Reveal>
            </li>)}
        </ul>
      </div>
    </section>;
}